import { Button } from 'antd'
import { toNumber } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { BidMemberListButtonProps } from './interface'

export const BidMemberListButton = ({ record }: BidMemberListButtonProps) => {
  const { setCurrentAuction, toggleBidMemberListModalVisible } =
    useAuctionListStore(state =>
      pick(state, ['setCurrentAuction', 'toggleBidMemberListModalVisible'])
    )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleBidMemberListModalVisible(true)
  }

  const status = toNumber(record.status ?? AuctionMemberPageStatus.WAIT_PUBLISH)

  return status >= AuctionMemberPageStatus.WAIT_START ? (
    <Button type='link' onClick={handleClick}>
      参与人员
    </Button>
  ) : null
}
